import React from 'react';

import ProductImage from './product-image';
import ProductPrice from './product-price';
import ProductDetailRow from './product-detail-row';
import KspList from './ksp-list';
import PurchaseButtonContainer from './purchase-button-container';
import { Helpers } from '../../core/src/helpers';
import Link from '../../shared/components/hyperlink';
import Modal from '../../shared/components/modal';
import GiftCard from '../../gift-card';

import '../css/product-detail-modal.less';


 class ProductDetailModal extends React.Component {
    modalContent() {
        let {
                product,
                price,
                jumpInfo,
                enableAppPDP,
                disableXsellPopup
            } = this.props;
        let urlParams = Helpers.getPDPJumpId(product, jumpInfo);
        const productUrl = `${process.env.BASENAME}/pdp/${product.linkUrl.split('/').pop()}`;
        
        return (
            <div className="product-detail-modal">
                <ProductImage 
                    product={product} 
                    link={productUrl} 
                    lazyLoad={true} 
                    maxImgWidth={640}
                />
                <div className="product-details">
                    <h2 tabIndex={0} aria-labelledby="Product Title">{product.name}</h2>
                    <GiftCard product={product}>
                    {
                        props => {
                            const { isGiftCard, giftCardForm, purchaseOptions, validateForm } = props;
                            const { itemId:variantId } = purchaseOptions;

                            return (
                                <React.Fragment>
                                    {giftCardForm}
                                    <ProductPrice product={product}  variantId={variantId}/>
                                    <ProductDetailRow product={product}/>
                                    <PurchaseButtonContainer 
                                        product={product} 
                                        showSelector={!isGiftCard}
                                        disableXsellPopup={disableXsellPopup}
                                        variant={purchaseOptions} 
                                        onClick={validateForm}
                                        jumpid={urlParams.jumpid}
                                    />
                                    <KspList ksps={product.ksps}/>
                                    <div className="full-details">
                                        <Link to={productUrl} newTab={true} className="full-details-open">View Full Details</Link>
                                    </div>
                                </React.Fragment>
                            );
                        }
                    }
                    </GiftCard>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} closeModal={this.props.closeModal}>
                {this.props.isOpen ? this.modalContent() : null}
            </Modal>
        );
    }
};

export default ProductDetailModal;